import * as z from 'zod';

import { withPasswordRequirements } from '@/modules/common/validations/password-requirements';

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'common:error.required'),
    newPassword: withPasswordRequirements(z.string().trim().min(1, 'common:error.required')),
    confirmNewPassword: z.string().trim().min(1, 'common:error.required'),
  })
  .refine(data => data.newPassword !== data.currentPassword, {
    path: ['newPassword'],
    message: 'authenticated.settings:pages.password.error.passwordsMustBeDifferent',
  })
  .refine(data => data.newPassword === data.confirmNewPassword, {
    path: ['confirmNewPassword'],
    message: 'authenticated.settings:pages.password.error.passwordsDoNotMatch',
  });

export type ChangePasswordFormData = z.infer<typeof changePasswordSchema>;
